import { render, staticRenderFns } from "./TestWebhook.vue?vue&type=template&id=2da5957e&scoped=true"
import script from "./TestWebhook.vue?vue&type=script&lang=js"
export * from "./TestWebhook.vue?vue&type=script&lang=js"
import style0 from "./TestWebhook.vue?vue&type=style&index=0&id=2da5957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5957e",
  null
  
)

export default component.exports